<script>
import DateRangeSelect from '@/components/DateRangeSelect';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    projectOptions: {
      type: Array,
      default: () => ([]),
    },
    workerOptions: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    emitUpdate (newValue) {
      this.$emit('change', {
        ...this.value,
        ...newValue,
      });
    },
    handleWorkerInput (value) {
      this.emitUpdate({ worker: value });
    },
    handleProjectInput (value) {
      this.emitUpdate({ project: value });
    },
    handleDatesChange (dates) {
      this.emitUpdate(dates);
    },
  },
  render () {
    const { $style } = this;
    const { worker, project, minDate, maxDate } = this.value;

    return (
      <div class={$style.wrapper}>
        {(this.workerOptions.length > 0) && (
          <u-select
            class={$style.input}
            value={worker}
            placeholder="Сотрудник"
            resetText="Все сотрудники"
            options={this.workerOptions}
            onInput={this.handleWorkerInput}
          />
        )}
        {(this.projectOptions.length > 0) && (
          <u-select
            class={$style.input}
            value={project}
            placeholder="Проект"
            resetText="Все проекты"
            options={this.projectOptions}
            onInput={this.handleProjectInput}
          />
        )}

        <div class={$style.dateFilters}>
          <DateRangeSelect
            value={{ minDate, maxDate }}
            onChange={this.handleDatesChange}
          />
        </div>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  display: flex;
  justify-content: stretch;
}

.dateFilters {
  margin-left: auto;
}

.input {
  & + & {
    margin-left: 1em;
  }
}
</style>
